import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Button, Col, Input, Label, Row } from "reactstrap";
import { listSignals } from "../../../../actions/Signal/actions";
import ItemSelect from "../../../Forms/ItemSelect";
import CenterSearch from "./CenterSearch";
import StatusSelect from "./StatusSelect";

export default function Filter(props) {
  const labels = useSelector(state => state.addclaim.labels)
  const filter = useSelector(state => state.signals.filter)
  const [show, setShow] = useState(window.innerWidth > 760);
  const [dirty, setDirty] = useState({});
  const timer = useRef(null);
  const hideClass = show || "d-none";
  // const [filter, setFilter] = useState({ limit: 25, user_id: '', type: '', status: '', warranty_request: '', a_number: '', item_number: '', created: '', offset: 0, is_lna: { value: '', label: 'ALL' } });
  const dispatch = useDispatch();


    useEffect(() => {
        // useRef value stored in .current property
        timer.current = setTimeout(() => dispatch(listSignals(dirty)), 330);

        // clear on component unmount
        return () => {
            clearInterval(timer.current);
        };
    }, [dirty, dispatch]);


  return (
    <Row className="py-3 justify-content-between">
      <Col md="6" xs="12" lg="2" className={hideClass}>
      <div className="pb-2 pb-lg-0">
        <Label>Date</Label>
        <Input type="text" value={dirty.created} onChange={(e) => setDirty({ created: e.target.value })} placeholder="YYYY-MM-DD"></Input>
        </div>
      </Col>
      <Col md="6" xs="12" lg="2" className={hideClass}>
        <div className="pb-2 pb-lg-0">
          <CenterSearch filter={filter} setFilter={(filter) => dispatch(listSignals(filter)) } />
        </div>
      </Col>
      <Col md="6" xs="12" lg="2" className={hideClass}>
        <div className="pb-2 pb-lg-0">
          <Label>{labels.warranty_request.label}</Label>
          <Input type="text" value={dirty.warranty_request} onChange={(e) => setDirty({ warranty_request: e.target.value })} placeholder=""></Input>
        </div>
      </Col>
      <Col md="6" xs="12" lg="2" className={hideClass}>
        <div className="pb-2 pb-lg-0">
          <Label>{labels.a_number.label}</Label>
          <Input type="text" value={dirty.a_number} onChange={(e) => setDirty({ a_number: e.target.value })} placeholder=""></Input>
        </div>
      </Col>
      <Col md="6" xs="12" lg="2" className={hideClass}>
        <div className="pb-2 pb-lg-0">

        <ItemSelect
          label="Item"
          name="item_number"
          id="item_number"
          onChange={(_,value) => dispatch(listSignals({ item_number: value }))}
          value={filter.item_number ? filter.item_number.value : ""}
          />
          </div>
      </Col>
      <Col md="6" xs="12" lg="2" className={hideClass}>
        <div className="pb-2 pb-lg-0">

        <StatusSelect
          label="Status"
          name="status"
          id="status"
          onChange={(value) => dispatch(listSignals({ status: value}))}
            value={filter.status ? filter.status.value : ""}
          />
        </div>
      </Col>

      <Col xs="3" className="d-md-none ms-auto" >
        <label className="d-none d-lg-block">&nbsp;</label>
        <Button type="button" className="w-100" onClick={() => setShow(!show)}>
          <FontAwesomeIcon icon={["far", "filter"]} />
        </Button>
      </Col>
    </Row>
  )

}
